export const getAssessment = (settingsData, category) =>
  settingsData?.assessments?.[category?.toLowerCase()];

export const getSelectedAssessment = (settingsData, formData) =>
  Object.values(settingsData?.assessments || {})
    .find(assessment => assessment.categoryField && formData?.[assessment.categoryField]);
